import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBq_oSqumMUSj00Yhh7wz12TMFnGtOe1kA",
  authDomain: "challenge-a252a.firebaseapp.com",
  databaseURL: "https://challenge-a252a.firebaseio.com",
  projectId: "challenge-a252a",
  storageBucket: "challenge-a252a.appspot.com",
  messagingSenderId: "796980281012",
  appId: "1:796980281012:web:09fc75dc82440a3d98a1e1",
  measurementId: "G-VZSSJMVRW7",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
